<div class="rf-pagina">
    <small class="rf-descricao">Rejeições da SEFAZ na emissão de NF-e/NFC-e, com o XML enviado. Ficam guardadas por
        {{ retencaoDias }} dias.</small>

    <div class="p-fluid p-grid rf-filtros">
        <div class="p-col-6 p-md-2">
            <habil-label name="rfCnpj" label="CNPJ">
                <input type="text" pInputText [(ngModel)]="filtro.cnpj" (keyup.enter)="buscar()">
            </habil-label>
        </div>
        <div class="p-col-6 p-md-2">
            <habil-label name="rfCStat" label="cStat">
                <input type="number" pInputText [(ngModel)]="filtro.cStat" (keyup.enter)="buscar()">
            </habil-label>
        </div>
        <div class="p-col-6 p-md-2">
            <habil-label name="rfNota" label="Nota">
                <input type="text" pInputText [(ngModel)]="filtro.nroNota" (keyup.enter)="buscar()">
            </habil-label>
        </div>
        <div class="p-col-6 p-md-2">
            <habil-label name="rfModelo" label="Modelo">
                <p-dropdown [options]="modelos" [(ngModel)]="filtro.modelo" appendTo="body"></p-dropdown>
            </habil-label>
        </div>
        <div class="p-col-6 p-md-2">
            <habil-label name="rfAmbiente" label="Ambiente">
                <p-dropdown [options]="ambientes" [(ngModel)]="filtro.ambiente" appendTo="body"></p-dropdown>
            </habil-label>
        </div>
        <div class="p-col-6 p-md-2 p-col-align-end">
            <button pButton label="Buscar" icon="pi pi-search" [disabled]="loading" (click)="buscar()"></button>
        </div>
    </div>

    <div *ngIf="erro" class="p-error">{{ erro }}</div>

    <div class="rf-tabelas">
        <div class="rf-coluna rf-coluna-resumo" *ngIf="resumo.length">
            <p-table [value]="resumo"
                styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines rf-lista rf-resumo"
                selectionMode="single"
                (onRowSelect)="filtraPorCStat($event.data.cStat)">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 60px;">cStat</th>
                        <th>Motivo</th>
                        <th style="width: 52px;">Qtd</th>
                        <th style="width: 70px;">Clientes</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-r>
                    <tr [pSelectableRow]="r">
                        <td>{{ r.cStat }}</td>
                        <td>{{ r.xStat }}</td>
                        <td>{{ r.total }}</td>
                        <td>{{ r.clientes }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div class="rf-coluna rf-coluna-lista">
            <p-table [value]="lista"
                [lazy]="true"
                [paginator]="true"
                [rows]="length"
                [first]="start"
                [totalRecords]="total"
                [rowsPerPageOptions]="[25, 50, 100]"
                (onLazyLoad)="paginar($event)"
                [loading]="loading"
                selectionMode="single"
                (onRowSelect)="abrir($event.data)"
                styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines rf-lista rf-rejeicoes">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Data</th>
                        <th>CNPJ</th>
                        <th>Modelo</th>
                        <th>Amb.</th>
                        <th>Nota/Série</th>
                        <th style="width: 60px;">cStat</th>
                        <th>Motivo</th>
                        <th>Versão</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-r>
                    <tr [pSelectableRow]="r">
                        <td>{{ r.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                        <td>{{ r.cnpj }}</td>
                        <td>{{ r.modelo }}</td>
                        <td>{{ r.ambiente === 'HOMOLOGACAO' ? 'Homol.' : (r.ambiente === 'PRODUCAO' ? 'Prod.' : r.ambiente) }}</td>
                        <td>{{ r.nroNota }}/{{ r.serie }}</td>
                        <td>{{ r.cStat }}</td>
                        <td>{{ r.xStat }}</td>
                        <td>{{ r.versao }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="8">Nenhuma rejeição encontrada.</td></tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<p-dialog header="Rejeição fiscal" [(visible)]="mostraDetalhe" [modal]="true"
    [style]="{width: '70vw'}" [dismissableMask]="true">
    <div *ngIf="detalhe">
        <p><b>{{ detalhe.cStat }}</b> - {{ detalhe.xStat }}</p>
        <p>
            CNPJ {{ detalhe.cnpj }} · {{ detalhe.modelo }} · {{ detalhe.ambiente }} ·
            Nota {{ detalhe.nroNota }}/{{ detalhe.serie }} · Usuário {{ detalhe.usuario }} ·
            Versão {{ detalhe.versao }} · {{ detalhe.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}
        </p>
        <p *ngIf="detalhe.chaveAcesso">Chave: {{ detalhe.chaveAcesso }}</p>
        <p *ngIf="detalhe.movimentacao && detalhe.movimentacao !== '0'">Movimentação: {{ detalhe.movimentacao }} {{ detalhe.tipo }}</p>
        <p><b>XML enviado</b>
            <button pButton type="button" label="Baixar XML" class="p-button-sm p-ml-2"
                style="width: auto;" [disabled]="!detalhe.xml" (click)="baixarXml()"></button></p>
        <pre *ngIf="detalhe.xml" style="max-height: 45vh; overflow: auto; white-space: pre-wrap; word-break: break-all;">{{ detalhe.xml }}</pre>
        <small *ngIf="!detalhe.xml && !carregandoDetalhe">Sem XML registrado para esta rejeição.</small>
        <small *ngIf="carregandoDetalhe">Carregando...</small>
    </div>
</p-dialog>
